<ul
    nz-menu
    nzMode="inline"
    class="modules-list flex flex-col gap-1 overflow-x-clip border-x-0 py-6"
    [nzSelectable]="false"
>
    @for (block of moduleList; track trackByBlockTitle($index, block)) {
        @if (!isExpanded) {
            <li class="module-title-container my-3 px-2">
                <p class="module-title text-black/45">{{ block.blockTitle | translate }}</p>
            </li>
        }
        @for (module of block.modules; track trackByModuleName($index, module)) {
            <li app-sidebar-block [moduleItem]="module" [isExpanded]="isExpanded"></li>
        }
    }
</ul>
